import * as React from 'react';
import { PageWrapper } from '../../uiComponents/layout/PageWrapper';
import { PageTitle } from '../../uiComponents/layout/PageTitle';
import { Grid, Row, DropdownButtonItem, Col } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import { ContentWrapper } from '../../uiComponents/layout/ContentWrapper';
import { Loading } from '../../uiComponents/Loading';
import { SectionGroup } from '../../uiComponents/layout/SectionGroup';
import { Section } from '../../uiComponents/layout/Section';
import { RouteComponentProps } from 'react-router';
import { createApiCaller } from '../../infrastructure/api/ApiFactory';
import { TilmeldingerForKonkurrence } from '../../models/TilmeldingerForKonkurrence';
import Table from '../../uiComponents/table/Table';
import { TableHeaderColumn } from 'react-bootstrap-table';
import { LinkPrimaryButton, OverflowDropdownButton } from '../../uiComponents/input/Buttons';
import Moment from 'react-moment';
import { Konkurrence } from '../../models/Konkurrence';
import { TextFormGroup } from '../../uiComponents/input/FormGroups';
import { TilmeldingFilter } from '../../models/TilmeldingFilter';
import { SkoleaarDropdown } from '../../uiComponents/input/SkoleaarDropDown';
import TableFormatters from '../../uiComponents/table/TableFormatters';
import { getLoggedInBruger } from '../../infrastructure/Security';
import { BrugerRolleEnum } from '../../models/enums/BrugerRolleEnum';

export interface TilmeldteHoldProps extends RouteComponentProps<any> {
}

export interface TilmeldteHoldState {
    tilmeldinger?: TilmeldingerForKonkurrence[];
    tilmeldingerFiltered?: TilmeldingerForKonkurrence[];
    konkurrence?: Konkurrence;
    filter: TilmeldingFilter;
}

class TilmeldteHold extends React.Component<TilmeldteHoldProps, TilmeldteHoldState> {
    constructor(props: TilmeldteHoldProps) {
        super(props);

        this.state = { tilmeldinger: undefined, tilmeldingerFiltered: undefined, filter: new TilmeldingFilter() };
        this.ekstraLaerereFormatter = this.ekstraLaerereFormatter.bind(this);
        this.menuFormatter = this.menuFormatter.bind(this);
        this.dateFormatter = this.dateFormatter.bind(this);
        this.onFilterChanged = this.onFilterChanged.bind(this);
    }

    componentDidMount() {
        var konkurrenceId = this.props.match.params.id;
        const apiCaller = createApiCaller();
        apiCaller.getTilmeldingerForKonkurrence(konkurrenceId).then(response =>
            this.setState({ tilmeldinger: response, tilmeldingerFiltered: response })
        );
        apiCaller.getKonkurrence(konkurrenceId).then(response =>
            this.setState({ konkurrence: response })
        );
    }

    ekstraLaerereFormatter(cell: any, row: any) {
        return row.ekstraLaerere.join(', ');
    }

    ansvarligLaererFormatter(cell: any, row: any) {
        return row.ansvarligLaerer + ' (' + row.brugernavn + ')';
    }

    getTableContextMenu() {
        const rolle = getLoggedInBruger().rolle;
        if (rolle !== BrugerRolleEnum.Ekstern) {
            return <TableHeaderColumn width='60' dataFormat={this.menuFormatter} className='table-menu' columnClassName='table-menu' />;
        }
        return null;
    }

    menuFormatter(cell: any, row: any) {
        return (
            <OverflowDropdownButton>
                <DropdownButtonItem href={'/tilmelding/rediger/' + row.id} text='Redigér' />
            </OverflowDropdownButton>
        );
    }

    dateFormatter(cell: any, row: any) {
        return (
            <Moment format='DD.MM.YY'>{cell}</Moment>
        );
    }

    onFilterChanged(fieldName: string, value: string) {

        const filter = this.state.filter;
        filter[fieldName] = value;
        this.setState({ filter: filter });

        if (this.state.tilmeldinger === undefined) {
            return;
        }

        const searchTerm = filter.search === undefined ? '' : filter.search.toLowerCase();
        let tilmeldinger = this.state.tilmeldinger.filter(t =>
            t.holdnavn.toLowerCase().indexOf(searchTerm) > -1 ||
            t.institutionsnavn.toLowerCase().indexOf(searchTerm) > -1 ||
            t.ansvarligLaerer.toLowerCase().indexOf(searchTerm) > -1 ||
            t.ekstraLaerere.some(e => e.toLowerCase().indexOf(searchTerm) > -1)
        );

        tilmeldinger = tilmeldinger.filter(t => Number(t.skoleAar) === Number(this.state.filter.skoleaar));

        this.setState({ tilmeldingerFiltered: tilmeldinger });
    }

    getTilmeldHoldButton() {
        const rolle = getLoggedInBruger().rolle;
        if (rolle !== BrugerRolleEnum.Administrator || this.state.konkurrence === undefined) {
            return null;
        } else {
            let tilmeldHoldUrl = '/tilmelding/tilmeld-hold/' + this.state.konkurrence.id;
            return <LinkPrimaryButton text={'Tilmeld hold'} url={tilmeldHoldUrl} />;
        }
    }

    render() {
        let header = <span />;
        if (this.state.tilmeldingerFiltered !== undefined && this.state.konkurrence !== undefined) {
            const startDate = <Moment format='DD.MM.YY'>{this.state.konkurrence.startdato.toString()}</Moment>;
            header = <span>{startDate} {this.state.konkurrence.titel} - {this.state.tilmeldingerFiltered.length} hold</span>;
        }

        return (
            <PageWrapper>
                <PageTitle title='Tilmeldte hold' />
                <div id='controls-wrapper'>
                    <Grid>
                        <Row>
                            <Col md={3}>
                                <SkoleaarDropdown
                                    onChange={this.onFilterChanged}
                                    selectedValue={this.state.filter.skoleaar}
                                />
                            </Col>
                            <Col md={4} mdOffset={5}>
                                <TextFormGroup
                                    errorMessages={[]}
                                    label='Søg efter tilmelding'
                                    name='search'
                                    value={this.state.filter.search}
                                    onChange={this.onFilterChanged}
                                />
                            </Col>
                        </Row>
                    </Grid>
                </div>
                <ContentWrapper>
                    <Loading isLoading={this.state.tilmeldingerFiltered === undefined}>
                        <SectionGroup header={header} buttons={this.getTilmeldHoldButton()} >
                            <Section fullWidth={true}>
                                <Table data={this.state.tilmeldingerFiltered} pagination={true} emptyText='Ingen tilmeldinger' >
                                    <TableHeaderColumn dataField='id' isKey={true} hidden={true} dataAlign='center' />
                                    <TableHeaderColumn dataField='institutionsnavn' className='first' columnClassName='first' dataSort={true}>Skole</TableHeaderColumn>
                                    <TableHeaderColumn dataField='holdnavn' width={'80'} dataSort={true}>Hold</TableHeaderColumn>
                                    <TableHeaderColumn dataField='ansvarligLaerer' width={'*'} dataFormat={this.ansvarligLaererFormatter} dataSort={true}>Ansvarlig lærer</TableHeaderColumn>
                                    <TableHeaderColumn dataField='ekstraLaerere' dataFormat={this.ekstraLaerereFormatter} dataSort={true}>Ekstra lærere</TableHeaderColumn>
                                    <TableHeaderColumn dataField='paaVenteliste' dataFormat={TableFormatters.tilmeldingStatusFormatter} width={'80'} dataSort={true}>Status</TableHeaderColumn>
                                    <TableHeaderColumn dataField='email' dataSort={true}>Email</TableHeaderColumn>
                                    {this.getTableContextMenu()}
                                    <TableHeaderColumn dataField='brugernavn' hidden={true} />
                                </Table>
                            </Section>
                        </SectionGroup>
                    </Loading>
                </ContentWrapper>
            </PageWrapper>
        );
    }
}

export default TilmeldteHold;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/tilmeldingerForKonkurrence/TilmeldteHold.tsx